export default __webpack_public_path__ + "static/media/Theinhardt-Bold.1801dd36.otf";